import { v4 } from 'uuid';

export const classnames = (...args: string[]) => {
  return args.join(' ');
};

export const generateUUID = () => {
  return v4();
};

export const getFormattedDateTime = () => {
  const now = new Date();
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    // hour: "2-digit",
    // minute: "2-digit",
    // second: "2-digit",
  };
  const localeDateString = now.toLocaleDateString('ja-JP', options);
  return localeDateString;
};
